<template>
	<div>
		<app-table
			name="tools-list"
			title="Configuración - Tipos de niveles"
			:clean-search="cleanSearch"
			:filter-columns="false"
			:rows="rows"
			:columns="columns"
			:main-list="false"
			class="is-not-selectable no-main-list"
			@on-search-event="onSearch"
		>
			<template slot="rows" slot-scope="{ row }">
				<td v-show="showRow(columns, 1)" class="is-not-selectable border-top">{{ row.level }}</td>
				<td v-show="showRow(columns, 2)" class="border-top">{{ row.name }}</td>
				<td v-show="showRow(columns, 3)" class="border-top">
					<v-layout wrap align-center justify-center>
						<app-tooltip-button
							text="Editar"
							:img="`${$imageUrl}/edit.svg`"
							@click-icon="editTool(row)"
						/>
						<app-tooltip-button
							:img="`${$imageUrl}/delete-button.svg`"
							text="Eliminar"
							color="info"
							@click-icon="deleteTool(row)"
						/>
					</v-layout>
				</td>
			</template>
		</app-table>
	</div>
</template>
<script>

function onSearch() {}

function editTool() {}

function deleteTool() {}

function data() {
	return {
		cleanSearch: false,
	};
}

export default {
	name: 'level-types-list',
	data,
	methods: {
		editTool,
		deleteTool,
		onSearch,
	},
	props: {
		columns: {
			required: true,
			type: Array,
		},
		rows: {
			required: true,
			type: Array,
		},
	},
};
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/configuration/types/level-types-list.vue